export default {
  getToken: function () {
    return localStorage.getItem('token')
  },
  setToken: function (token) {
    localStorage.setItem('token', token)
  },
  setMsisdn: function (msisdn) {
    localStorage.setItem('msisdn', msisdn)
  },
  getMsisdn: function () {
    return localStorage.getItem('msisdn')
  },
  setProvider: function (provider) {
    localStorage.setItem('provider', provider)
  },
  getProvider: function () {
    return localStorage.getItem('provider')
  },
  removeToken: function () {
    localStorage.removeItem('token')
  },
  removeProvider: function () {
    localStorage.removeItem('provider')
    localStorage.removeItem('providerCountry')
    localStorage.removeItem('provider_msj')
    localStorage.removeItem('provider_n')
    localStorage.removeItem('provider_email')
  },
  removeMsisdn: function () {
    localStorage.removeItem('msisdn')
  },
  getHeader: function () {
    return {'access-token': this.getToken()}
  }
}

export * from './authGuard'
export * from './authWrapper'



// WEBPACK FOOTER //
// ./src/auth/index.js